import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/org/$org/communications')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/admin/communications',
      search: { 
        org: params.org,
        userId: undefined,
        topicId: undefined,
        status: undefined,
        cursor: undefined,
      },
    })
  },
})
